import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import '../../assets/css/Packages.css';
import '../../assets/css/AllBlogs.css';
import { useDispatch } from 'react-redux';
import { BlogsByPagination, GetAllBlogs } from '../../Redux/Auth/Auth_Action';
import { toast } from 'react-toastify';


const AllBlogs = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const [blogs, setBlogs] = useState({ allBlogs: [] });

    const GetBlogs = () => {
        dispatch(GetAllBlogs())
            .then((res) => {
                // console.log("res from all blogs", res);
                setBlogs({ ...blogs, allBlogs: res.data.response.data })
            })
            .catch((e) => {
                console.log(e, 'error from all blogs page');
                toast.error("Network error");
            })
    }

    const BlogPagination = (e) => {
        // console.log("working button", e);
        dispatch(BlogsByPagination(e))
            .then((res) => {
                // console.log('response from podcastpagination', res);
                setBlogs({ ...blogs, allBlogs: res.data.response.data });
            }).catch((e) => {
                console.log(e, "error from podastpagination")
                toast.error("Network error");
            })
    }

    useEffect(() => {
        window.scroll(0, 0);
        GetBlogs();
    }, [])

    // console.log(blogs);


    return (
        <div className='about_us packages all_blogs'>
            <section className='reamining_header_background pos-rel'>
                <Header />

                <InnerHeaderContent pageName={"BLOGS"} />
            </section>
            <section className='pkg_content'>
                <div className='container'>
                    <div>
                        <h4 className='sub-title mt-5'>BLOGS & NEWS</h4>
                        <h2 className='main-title'>READ OUR LASTEST POSTING</h2>
                        <div className="border-btm-pink-secondsec mt-3 mb-4"></div>
                        <p className='main-para mb-5 text-center'>Here you can find out the latest news on all online game prediction and other sports.
                            Get every sport bet challenger news and updates here.
                        </p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 mt-5'>
                            {blogs?.allBlogs?.data?.map((item, index) => {
                                return (
                                    <div key={index} className='blog-div-details'>
                                        {
                                            (item?.media_url?.slice(-3) === "mp4") ?
                                                <video width="100%" height="500" controls controlsList="nodownload" >
                                                    <source src={`${item?.media_url}`} type="video/mp4" />
                                                </video>
                                                :
                                                <img src={item?.media_url} className="blog_image_single mb-4" alt="recommended blogs" />
                                        }
                                        <p className='f-mon-bold f-26'>{item?.title}</p>
                                        <p className='f-mon-light f-13 clr-a1'>
                                            <span className='ml-1'>{item?.updated_at.slice(5, 7)}</span>
                                            <span>{item?.updated_at?.slice(7, 10)}</span>
                                            <span>-{item?.updated_at?.slice(0, 4)}</span>
                                        </p>
                                        {/* <p className='f-mon-light f-20 f-ellipse' dangerouslySetInnerHTML={{ __html: item.description }}>
                                        </p> */}
                                        <div className=''></div>
                                        <Link to={`/blogdetails/${item.id}`}>
                                            {/* <p className='read_more mt-4 mb-5 f-mon-med f-12 text-white'>
                                                Read More
                                            </p> */}
                                            <button className='btn btn-light btn-rdmrr mt-2 mb-4'>
                                                Read More
                                            </button>
                                        </Link>

                                        {(blogs?.allBlogs?.data?.length - 1 === index) ?
                                            <></>
                                            :
                                            <div className='brdr-btm-blogs-light'></div>
                                        }
                                    </div>
                                )
                            })}

                        </div>
                        {/* <div className='col-lg-4 mt-5'>
                            {side_recommended.map((item, index) => {
                                return (
                                    <div key={index} onClick={() => { navigate("/blogdetails") }} className='blog_recommended cursor_pointer'>
                                        <img src={item.image} className="blog_image_single" alt="recommended blogs" />
                                        <p className='f-pop-semibold f-24'>{item.heading}</p>
                                        <p className='f-pop-reg f-18'>{item.description}</p>
                                        <p className='read_more mt-4 mb-5 f-mon-med f-16'>Read More</p>
                                    </div>
                                )
                            })}
                        </div> */}
                        <div className='col-lg-12 text-center mt-4'>
                            {blogs?.allBlogs?.links?.map((item, index) => {
                                if (item.label === "&laquo; Previous") {
                                    item.label = "Previous";
                                    return (
                                        <button key={index + 100}
                                            onClick={() => { BlogPagination(item.url) }}
                                            disabled={(item.url === null ? true : false)}
                                            className='btn btn-light bt-pagination-all'>
                                            {item.label}
                                        </button>
                                    )
                                } else if (item.label === "Next &raquo;") {
                                    item.label = "Next";
                                    return (
                                        <button key={index + 100}
                                            onClick={() => { BlogPagination(item.url) }}
                                            disabled={(item.url === null ? true : false)}
                                            className='btn btn-light bt-pagination-all'>
                                            {item.label}
                                        </button>
                                    )
                                } else {
                                    return (
                                        <button key={index + 100}
                                            onClick={() => { BlogPagination(item.url) }}
                                            disabled={(item.url === null ? true : false)}
                                            className='btn btn-light bt-pagination-all'>
                                            {item.label}
                                        </button>
                                    )
                                }
                            })}
                        </div>
                        {/* <div className='col-lg-12 text-center mt-5rem'>
                            <button className="btn-pink-now f-16 f-mon-reg">Load More</button>
                        </div> */}
                    </div>
                </div>
            </section>

            <section className='home-bg-fifth pos-rel overflow-hide-x'>
                <div className='bg-joinnow-shahke'>

                </div>
                <div className='container pt-5'>
                    <div className='col-lg-12 text-center mt-cus-allwewant'>
                        <p className='f-26 f-mon-reg mb-0 text-white'>ALL WE WANT IS TO COVER YOUR BET</p>
                        <p className='f-40 f-mon-bold clr-e0 lh-01'>GET COMPLIMENTARY OFFER</p>
                        <div className="border-btm-white-secondsec my-3"></div>
                        <p className="wdth-80-per text-white f-mon-light f-20 mt-4 mb-3">If you’re a first-time visitor, then you get the “Play of the Day” offer where you get ONE free sports betting advice or prediction on any upcoming game from our sports forecaster. So Click here and WIN.</p>
                        <p className="wdth-80-per text-white f-mon-light f-20 mt-4 mb-3">
                            Getting sports betting tips online may seem like a farfetched scheme but when you get the taste of becoming a winner with our first free sport betting predicting advice you will realize that this is not a scam but the real deal!
                        </p>
                        <button onClick={() => { navigate('/tips') }} className="btn btn-light f-16 f-mon-reg btn-pink-now mb-3 mt-4">GET BETTING TIPS</button>
                    </div>
                </div>
            </section>
            <section className='home-bg-eight'>
                <div className='container'>
                    <div className='join-container'>
                        <p className='sub-title'>What makes Prediction Dog The Big Dog on campus?</p>
                        <h2 className='main-title'>JOIN NOW</h2>
                        <hr className='hr-line' />
                        <p className='para'>With my 36 years of extensive experience in sports betting, I have the skills to properly analyze each game, each line, and each score to give a highly accurate result that will let you make it BIG in the betting world.</p>
                        <div className='btn-container'>
                            <button onClick={() => { navigate('/packages') }} className='btn join-btn'>Join Now</button>
                        </div>
                        <p className='para mt-4'>
                            As a sports forecaster, every analytics, history, and trend is carefully observed and evaluated to give you the WINNING EDGE and become famous sports bettors!
                        </p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default AllBlogs;
